import React from 'react';
import { Button } from './ui/Button';
export function UpsellSection() {
  return <section className="w-full bg-yellow-50 py-10 px-4 md:px-8 border-y-4 border-yellow-400" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <div className="text-center mb-6" data-id="element-194">
          <span className="inline-block bg-yellow-400 text-yellow-900 font-black text-lg px-6 py-2 rounded-full uppercase tracking-widest mb-3 animate-pulse" data-id="element-195">
            ⭐ MÁS POPULAR
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900" data-id="element-196">
            KIT COMPLETO PRIMARIA + SISTEMA PRO DE EVALUACIÓN
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-6 bg-white p-5 md:p-8 rounded-2xl shadow-lg" data-id="element-197">
          <div className="w-full md:w-1/2" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/gbBQUvzrNt2PkE4L6hP2vL/UPSELL_PRIMARIA_.png" alt="Super Kit Primaria + Evaluación" className="w-full rounded-lg hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={() => window.location.href = 'https://mi-tienda-pro-8012.myshopify.com/cart/48178792300763:1'} data-id="element-199" />
          </div>

          <div className="w-full md:w-1/2" data-id="element-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-201">Incluye:</h3>
            <ul className="space-y-2 mb-6" data-id="element-202">
              {['Kit Completo Primaria Lista', 'Banco de evaluaciones organizadas por materia', 'Rúbricas de corrección', 'Modelos de evaluación editables', '3 Bonos incluidos', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-203">
                  <span className="text-green-600 font-bold" data-id="element-204">✔</span>
                  <span className="text-gray-700" data-id="element-205">{item}</span>
                </li>)}
            </ul>

            <div className="mb-4" data-id="element-206">
              <p className="text-gray-500 text-sm mb-1" data-id="element-207">
                Valor separado <span className="line-through" data-id="element-208">$34.990 ARS</span>
              </p>
              <p className="text-4xl font-black text-[#16a34a]" data-id="element-209">
                HOY $24.990 ARS
              </p>
              <p className="text-sm font-bold text-green-600 mt-1 bg-green-100 inline-block px-2 py-1 rounded" data-id="element-210">
                Ahorrás $10.000 ARS
              </p>
            </div>

            <a href="https://mi-tienda-pro-8012.myshopify.com/cart/48178792300763:1" data-id="element-211">
              <Button fullWidth pulse className="text-lg py-4" data-id="element-212">
                👉 SÍ, QUIERO EL SUPER MEGA PACK
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}